import { BaseSuccessDto } from 'services/backofficeIntegration/http/BaseSuccessDto';
import { backofficeClient } from 'services/backofficeIntegration/http/client/createBackofficeClient';
import { mutationEndpoint } from 'services/backofficeIntegration/http/endpointDefinition';

export const httpDeleteCustomer = mutationEndpoint({
  callEndpoint: () => backofficeClient.delete<BaseSuccessDto<unknown>>('/customer'),
});
